import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityListComponent } from './pages/activity-list/activity-list.component';
import { ActivityRoutingModule } from './activity.routing';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { ActivityDetailComponent } from './components/activity-detail/activity-detail.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DistinctPRTapsPipe } from '../../shared/pipes/distinct-pr-taps.pipe';
import { TapsDetailComponent } from './components/activity-detail/taps-detail/taps-detail.component';
import { TapFareComponent } from './components/activity-detail/taps-detail/tap-fare/tap-fare.component';
import { TapFareMultivalidationComponent } from './components/activity-detail/taps-detail/tap-fare-multivalidation/tap-fare-multivalidation.component';
import { FindAccessMediaPipe } from '@app/shared/pipes/find-access-media.pipe';

@NgModule({
  declarations: [ActivityListComponent, ActivityDetailComponent, FindAccessMediaPipe, DistinctPRTapsPipe, TapsDetailComponent, TapFareComponent, TapFareMultivalidationComponent],
  imports: [
    CommonModule,
    SharedModule,
    ActivityRoutingModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    InfiniteScrollModule
  ]
})
export class ActivityModule {}
